module.exports = __webpack_public_path__ + "static/media/meme_6.ad8a4322.png";